// extracted by mini-css-extract-plugin
export var socialIcons = "bio-module--social-icons--16787";